module.exports = __webpack_public_path__ + "img/2.aa26b2b0.png";